import { useState, useEffect } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import axios from 'axios';
import { Card } from '@/components/ui/card';
import { Users, Wallet, Mail, Phone } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const AdminClientsPage = () => {
  const { getAuthHeaders } = useAuth();
  const [clients, setClients] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      try {
        const res = await axios.get(`${API}/admin/clients`, { headers: getAuthHeaders() });
        setClients(res.data);
      } catch (e) { console.error(e); } finally { setLoading(false); }
    };
    load();
  }, []);

  if (loading) return <div className="flex items-center justify-center h-64"><div className="w-10 h-10 border-4 border-blue-500 border-t-transparent rounded-full animate-spin" /></div>;

  return (
    <div className="space-y-6" data-testid="admin-clients-page">
      <div>
        <h1 className="text-2xl font-bold text-slate-900">Clientes Registrados</h1>
        <p className="text-slate-500">{clients.length} clientes en el sistema</p>
      </div>

      {clients.length === 0 ? (
        <Card className="p-12 text-center border-0 shadow-sm">
          <Users className="w-12 h-12 mx-auto text-slate-300 mb-3" />
          <p className="text-slate-500">No hay clientes registrados</p>
        </Card>
      ) : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {clients.map((c) => (
            <Card key={c.id} className="p-4 border-0 shadow-sm" data-testid={`client-${c.id}`}>
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 rounded-full bg-emerald-500 flex items-center justify-center text-white font-semibold shrink-0">
                  {c.name?.charAt(0).toUpperCase() || 'C'}
                </div>
                <div className="min-w-0 flex-1">
                  <p className="font-semibold text-slate-900 truncate">{c.name}</p>
                  <div className="flex items-center gap-1 text-xs text-slate-500 mt-1">
                    <Mail className="w-3 h-3" /> <span className="truncate">{c.email}</span>
                  </div>
                  {c.phone && (
                    <div className="flex items-center gap-1 text-xs text-slate-500">
                      <Phone className="w-3 h-3" /> {c.phone}
                    </div>
                  )}
                  <div className="flex items-center gap-1 mt-2">
                    <Wallet className="w-4 h-4 text-emerald-500" />
                    <span className="font-bold text-emerald-600">${(c.wallet_balance || 0).toFixed(2)}</span>
                  </div>
                  <div className="flex items-center gap-2 mt-1 text-xs text-slate-400">
                    <span>Ref: {c.referral_code}</span>
                    <span>Pts: {c.points || 0}</span>
                  </div>
                  <p className="text-xs text-slate-400 mt-1">Desde: {new Date(c.created_at).toLocaleDateString('es-ES')}</p>
                </div>
              </div>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
};

export default AdminClientsPage;
